export default __webpack_public_path__ + "static/media/proyek-bank.04fe838e.png";